<template>
    <div class="gauge-bar">
        <span class="icon-gauge">
            <i class="percent" :style="{width: setPecent +'%'}"></i>
        </span>
        <em v-if="isNumberShow" class="percent-num">{{setPercentNum}} %</em>
    </div>
</template>

<script>
export default {
    name: 'ScpmGaugeBar',
    props: {
        percentNum: {
            type: [Number, String],
            default: 0
        },
        isNumberShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
        setPecent() {
            return parseInt(this.percentNum, 10);
        },
        setPercentNum() {
            return Number(this.percentNum).toFixed(2) ;
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.gauge-bar {
    .icon-gauge {
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        width: 90px;
        height: 14px;
        border-radius: 7px;
        background-color: rgba(31, 37, 51, 0.08);
        overflow: hidden;

        .percent {
            display: block;
            width: 0;
            height: 14px;
            background-color: var(--greenblue);
        }
    }
    
    .percent-num {
        display: inline-block;
        margin: 0 0 0 19px;
        font-family: $lego__font-family;
        font-size: 14px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: right;
        color: var(--dark);
    }
}
</style>